import React from "react";

import * as styles from "./styles.scss";

export default ( props ) => <div className={ styles.buttonsContainer } { ...props } />;
